module.exports = __webpack_public_path__ + "static/media/StarterSticker.aa42b76d.svg";